export default __webpack_public_path__ + "static/media/partners-card.b7dc4ed8.png";